import React from 'react';
import { Flex, ScrollArea } from '@mantine/core';
import KanbanColumn from './KanbanColumn';

const KanbanBoard = ({ activityData = [], onTaskClick }) => {
    const columns = [
        { id: 'PND', title: 'Pendiente', iconClass: 'icon-clock', color: 'orange', bgColor: '#FDE9D9' },
        { id: 'PRG', title: 'En progreso', iconClass: 'icon-play', color: 'blue', bgColor: '#d1ecf1' },
        { id: 'COM', title: 'Completa', iconClass: 'icon-check-check', color: 'green', bgColor: '#d4edda' },
        { id: 'CAN', title: 'Cancelada', iconClass: 'icon-ban', color: 'red', bgColor: '#f8d7da' },
        { id: 'APR', title: 'Aprobada', iconClass: 'icon-thumbs-up', color: 'teal', bgColor: '#d1f2eb' },
        { id: 'REC', title: 'Rechazada', iconClass: 'icon-thumbs-down', color: 'grape', bgColor: '#f3e5f5' },
    ];

    const groupedActivities = activityData.reduce((groups, activity) => {
        const statusCode = activity.activity_status?.code || 'PND'; 
        if (!groups[statusCode]) {
            groups[statusCode] = [];
        }
        groups[statusCode].push(activity);
        return groups;
    }, {});

    return (
        <Flex gap="md" >
            {columns.map(column => (
                <KanbanColumn
                    key={column.id}
                    column={column}
                    tasks={groupedActivities[column.id] || []}
                    onTaskClick={onTaskClick}
                />
            ))}
        </Flex>
    );
};

export default KanbanBoard;